import { persistState } from '@superbet-group/web.lib.vue-utilities';

import { stateRehydrate } from '@store/modules/ui/user/preferences/stateRehydrate';
import { IPreferencesStateLegacy } from '@store/modules/ui/user/preferences/types';

import { IState } from '..';

const triggerMutations = [
    /^ui\/sportOffer\//,
    /^ui\/sportOffer\/search\//,
    /^data\/authentication\//,
    /^ui\/sportOffer\/betSlip\/TOGGLE_BET_SLIP_AUTO_UPDATE_CHANGES/,
    /^ui\/user\/preferences\//,
];

/**
 * Please don't use authentincation.User in vuex persist. User is being explicitly saved to local storage
 * because if we use vuex persist lib, then we have a nasty bug because customers can open many tabs,
 * and sessionId in cookie and in localStorage can be out of sync
 * Check the description here: https://github.com/superbet-group/dot-country-web.client/pull/6649
 */
const persistedModules = [
    'ui.sportOffer.search',
    'ui.sportOffer.betSlip.autoUpdateChanges',
    'ui.sportOffer.sports.selectedTreeItems',
    'ui.user.preferences',
];

export const STATE_STORAGE_KEY = 'store';

type SavedState = IState | (IState & { ui: { user: { preferences: IPreferencesStateLegacy }}});

export default persistState<IState>({
    key: STATE_STORAGE_KEY,
    paths: persistedModules,
    filter: (mutation) => triggerMutations.some((regex) => regex.test(mutation.type)),
    getState(localStorageKey, localStorage) {
        try {
            const storedState = localStorage.getItem(localStorageKey);

            // No need for errors for this entire use case, it only happens on clean storage
            if (storedState == null) {
                return {} as unknown as IState; // Lying about types here, but it's fine for this use case
            }

            const state: SavedState = JSON.parse(storedState);

            return {
                ...state,
                ui: {
                    ...state.ui,
                    user: {
                        ...state.ui.user,
                        preferences: stateRehydrate(state.ui.user.preferences),
                    },
                },
            };
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            return {} as unknown as IState; // Lying about types here, but it's fine for this use case
        }
    },
});
